import { Component, OnDestroy, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { OpeningService } from '../opening.service';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ISelect } from 'app/shared/models/select.model';
import { RecruitmentService } from '../../recruitment/recruitment.service';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { IDtoRequisitionFilter } from 'app/shared/models/opening/dto-requisition-filter.model';
import { Observable } from 'rxjs';
import { SecurityService } from 'app/shared/services/security.service';
import { ModalReasonComponent } from 'app/views/modales/common/modal-reason.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { IDtoPosition } from 'app/shared/models/opening/dto-position.model';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { CustomerService } from '../../quote/customer.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { StorageService } from 'app/shared/services/storage.service';
import { PositionService } from '../../quote/position.service';
import { BudgetService } from '../../quote/budget.service';

@Component({
    selector: 'app-requisition-review',
    styleUrls: ['./requisition-review.style.scss'],
    templateUrl: 'requisition-review.template.html'
})
export class RequisitionReviewComponent implements OnDestroy, OnInit {
    /**Formularios */
    private formFilter: FormGroup;
    /**Catalogos */
    private catalogStatusRequests: Observable<ISelect[]>;
    private catalogFulfillments: Observable<ISelect[]>;
    private catalogMotiveVacancys: Observable<ISelect[]>;
    private catalogTrademarks: Observable<IDtoCatalog[]>;
    private catalogJobs: Observable<IDtoCatalog[]>
    private catalogProjects: Observable<IDtoCatalog[]>;
    private catalogPlans: Observable<IDtoCatalog[]>;
    private catalogZones: Observable<ISelect[]>;
    private catalogStates: Observable<ISelect[]>;
    private catalogTowns: Observable<ISelect[]>;
    /**Variables */
    private now: number;
    /**Listas */
    private requisitions: IDtoRequisition[];
    private requisitionsTemp: IDtoRequisition[];
    private town: string;
    private state: string;
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableRequisitions: DatatableComponent;
    /**Slim-control */
    optsSlim: ISlimScrollOptions;
    scrollEvents: EventEmitter<SlimScrollEvent>;
    private profile: string;
    private modalRef: BsModalRef;
    private requisition: IDtoRequisition;
    private errorMessages: any;
    private pos: IDtoPosition;
    private search: string;
    @ViewChild('swalCancelPosition', { static: false }) private swalCancelPosition: SwalComponent;
    @ViewChild('swalPausedPosition', { static: false }) private swalPausedPosition: SwalComponent;
    public constructor(private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private openingService: OpeningService
        , private recruitmentService: RecruitmentService
        , private customerService: CustomerService
        , private router: Router
        , private route: ActivatedRoute
        , private spinner: NgxSpinnerService
        , private configurationService: ConfigurationService
        , private securityService: SecurityService
        , private modalService: BsModalService
        , private storageService: StorageService
        , private identityService: IdentityService
        , private positionService: PositionService
        , private budgetService: BudgetService) {
        this.optsSlim = configGeneral.getConfigSlimScroll();
        this.initializeFormFilter();
        this.getProfile();
    }
    ngOnInit(): void {
        this.scrollEvents = new EventEmitter<SlimScrollEvent>();
        this.now = Date.now();
        if (this.configurationService.isReady) {
            this.getCatalogs();
            this.initFilters();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.getCatalogs();
                this.initFilters();
            });
        }        
    }
    ngOnDestroy(): void {
    }
    private initFilters(): void {
        const values = this.storageService.retrieve('requisitions.filters');
        if (values != null) {
            if (values.trademarkId != null) {
                let dto = { id: values.trademarkId } as IDtoCatalog;
                this.getCatalogJobsAndProjects(dto);
            }
            this.formFilter.patchValue(values);
        }
        const search = this.storageService.retrieve('requisitions.search');
        if (search != undefined) {
          this.search = search;
        }
        if (values != null) {
            this.getRequisitionsFilters();
        }
    }
    private initializeFormFilter() {
        this.formFilter = this.formBuilder.group({
            statusRequestId: [null],
            requisitionDate: [null],
            startDate: [null],
            lowDate: [null],
            closeDate: [null],
            fulfillmentId: [null],
            recruiter: [null],
            operator: [null],
            motiveVacancyId: [null],
            trademarkId: [null],
            codeNomJob: [null],
            positionNum: [null],
            job: [null],
            zone: [null],
            state: [null],
            town: [null],
            projectId: [null],
            plan: [null]
        });
    }
    private getRequisitionsFilters(): void {
        this.spinner.show();
        const data = this.formFilter.value as IDtoRequisitionFilter;
        data.profile = this.profile;
        this.openingService.getRequisitionByFilter(data).subscribe((res) => {
            if (res.isCorrect) {
                this.requisitions = res.data as IDtoRequisition[];
                this.requisitionsTemp = this.requisitions;
                if (this.search != undefined) {
                    this.updateFilter();
                }
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
            this.spinner.hide();
        });
    }

    private navigateTo(row: IDtoRequisition): void {
        const values = this.formFilter.value as IDtoRequisitionFilter;
        this.storageService.store('requisitions.filters', values);
        this.storageService.store('requisitions.search', this.search);
        this.router.navigate(['/openings/requisition-detail',
            { id: row.positionId, action: 'detail' }], { relativeTo: this.route });
    }
    private getCatalogs(): void {
        this.catalogZones = this.recruitmentService.getCatalogZones();
        this.catalogStatusRequests = this.openingService.getCatalogStatusRequests();
        this.catalogFulfillments = this.openingService.getcatalogFulfillments();
        this.catalogStates = this.recruitmentService.getCatalogStates();
        this.catalogTrademarks = this.customerService.getCatalogCustomers();
        this.catalogMotiveVacancys = this.openingService.getCatalogMotiveVacancys();
    }
    private getCatalogTowns(state: ISelect): void {
        this.catalogTowns = this.recruitmentService.getCatalogTowns(state.id);
    }
    private getCatalogJobsAndProjects(item: IDtoCatalog): void {
        this.formFilter.get('projectId').setValue(null);
        this.formFilter.get('job').setValue(null);
        this.catalogJobs = null;
        this.catalogProjects = null;
        if (item == null) {
            return;
        }
        this.catalogJobs = this.positionService.getCatalogPositionsByCustomerId(item.id);
        this.catalogProjects = this.budgetService.getCatalogProjectCustomersByCustomerId(item.id);
    }
    private getCatalogPlans(item: IDtoCatalog): void {
        this.formFilter.get('plan').setValue(null);
        this.catalogPlans = null;
        if (item == null) {
            return;
        }
        var plans = item.additional.split(',');
        var catalog = new Array() as IDtoCatalog[];
        plans.forEach(element => {
            let  v = {} as IDtoCatalog;
            v.name = element
            catalog.push(v);
        });
        this.catalogPlans = Observable.of(catalog)
    }
    private getProfile(): void {
        this.profile = this.securityService.getProfileStorage('RequisitionReviews');
    }
    private isRecruitments(): boolean {
        return this.profile === 'Reclutamiento'
    }
    private isOperations(): boolean {
        return this.profile === 'Operaciones'
    }
    private isEdit(status: number): boolean {
        if(this.isRecruitments()) {
            return status === 2;
        }
        if(this.isOperations()) {
            return status === 1 || status === 6;
        }
    }
    private isRead(status: number): boolean {
        if(this.isRecruitments()) {
            return status !== 2;
        }
        if(this.isOperations()) {
            let visible = true;
            if (status === 1 || status === 6) {
                visible = false;
            }
            return visible;
        }
    }
    private openModalCancelationReason(req: IDtoRequisition): void {
        this.requisition = req;
        const initialState = {
            title: 'Motivos',
            reason: null
        };
        this.modalRef = this.modalService.show(ModalReasonComponent
            , Object.assign({ initialState }
                , this.configGeneral.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.submitCancelPosition(result);
            }
        });
    }
    private openModalPausedReason(req: IDtoRequisition): void {
        this.requisition = req;
        const initialState = {
            title: 'Motivos',
            reason: null
        };
        this.modalRef = this.modalService.show(ModalReasonComponent
            , Object.assign({ initialState }
                , this.configGeneral.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.submitPausedPosition(result);
            }
        });
    }
    private cancelPosition(reason: string): void {
        this.openingService.cancelPosition(this.pos).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.requisition.statusRequestId = 5;
                    this.requisition.statusRequestDesc = 'CANCELADA';
                    this.configGeneral.newToast('Éxito', 'Posición cancelada correctamente', 'success');
                    this.addModuleLog('cancel');
                } else {
                    this.configGeneral.newToast('Error', x.message, 'error');
                }
            },
            (errMessage) => this.errorMessages = errMessage.messages);
    }
    private pausedPosition(reason: string): void {
        this.openingService.pausedPosition(this.pos).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.requisition.statusRequestId = 6;
                    this.requisition.statusRequestDesc = 'PAUSADA';
                    this.configGeneral.newToast('Éxito', 'Posición pausada correctamente', 'success');
                    this.addModuleLog('paused');
                } else {
                    this.configGeneral.newToast('Error', x.message, 'error');
                }
            },
            (errMessage) => this.errorMessages = errMessage.messages);
    }
    private submitCancelPosition(reason: string): void {
        this.pos = {} as IDtoPosition;
        this.pos.id = this.requisition.positionId;
        this.pos.cancellationReason = reason;
        this.swalCancelPosition.title = '¿Seguro que desea cancelar la posición seleccionada?';
        this.swalCancelPosition.show();
    }
    private submitPausedPosition(reason: string): void {
        this.pos = {} as IDtoPosition;
        this.pos.id = this.requisition.positionId;
        this.pos.pausedReason = reason;
        this.swalPausedPosition.title = '¿Seguro que desea pausar la posición seleccionada?';
        this.swalPausedPosition.show();
    }
    private updateFilter() {
        if (this.search === undefined) {
            return;
        }

        const val = this.search.toLowerCase();
        const temp = this.requisitionsTemp.filter((x: any) => x.trademarkDesc.toLowerCase().startsWith(val)
            || x.codeNomJob.toLowerCase().startsWith(val)
            || x.statusRequestDesc.toLowerCase().startsWith(val) 
            || x.codeNomPosition.toLowerCase().startsWith(val)
            || x.positionDesc.toLowerCase().startsWith(val)
            || x.zoneDesc.toLowerCase().startsWith(val)
            || x.stateDesc.toLowerCase().startsWith(val)
            || x.townDesc.toLowerCase().startsWith(val)
            || x.employeeName.toLowerCase().startsWith(val)
            || x.requisitionId.toString().startsWith(val) );
     
        this.requisitions = temp;
        this.tableRequisitions.offset = 0;
    }
    private addModuleLog(action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = "Positions";
        dto.module = 'requisitionReviews';
        dto.action = action;
        dto.registryAffectedId = this.requisition.positionId;
        this.identityService.addModuleLog(dto).subscribe(
          (x) =>{});
      }
}
